module.exports = __webpack_public_path__ + "static/media/icon-6.a23ba39b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mm/icon-6.png
// module id = 1031
// module chunks = 0